module.exports = __webpack_public_path__ + "img/w3_search_lighter.7a8737a7.png";